import React from "react";
import { Link, NavLink } from "react-router-dom"; // Make sure to import from 'react-router-dom'
import "../../assets/style.scss";
import { Col, Row } from "react-bootstrap";
import facebook from "../../assets/socilicons/fblogo.svg";
import twitter from "../../assets/socilicons/twitter-logo.svg";
import youtube from "../../assets/socilicons/youtube-logo.svg";
import instagram from "../../assets/socilicons/insta-logo.svg";
import foterimg from "../../assets/images/logo-footer.png";
import { Nav } from "react-bootstrap";

class Footer extends React.Component {
  render() {
    return (
      <>
        <div className="row">
          <div className="col-md-12">
            <div className="footer">
              <div className="container footer-inner-width">
                <Row>
                  <Col>
                    <div className="footerimg">
                      <Link to="/">
                        <img
                          className="footerlogopc"
                          src={foterimg}
                          alt="default"
                        />
                      </Link>
                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Nav className="footer-nav-links">
                      <a target="_blank" rel="noopener noreferrer" className="nav-link" href="https://www.maymadness7s.com/event">
                        Event Info
                      </a>
                      <NavLink className="nav-link" to="/how-to-play">
                        How To Play
                      </NavLink>
                      <a target="_blank" rel="noopener noreferrer" className="nav-link" href="https://www.maymadness7s.com/news">
                        News
                      </a>
                      <a target="_blank" rel="noopener noreferrer" className="nav-link" href="https://www.maymadness7s.com/contact-us">
                        Contact Us
                      </a>
                    </Nav>
                  </Col>
                </Row>
                <div className="hr-line"></div>
                <Row>
                  <Col>
                    <Nav className="socialmedia">
                      <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/nationalcollegiaterugby/">
                        <img src={facebook} alt="Facebook" />
                      </a>
                      <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/nationalcollegiaterugby/">
                        <img src={instagram} alt="Instagram" />
                      </a>
                      <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/c/NationalCollegiateRugby/featured">
                        <img src={youtube} alt="YouTube" />
                      </a>
                      <a target="_blank" rel="noopener noreferrer" href="https://twitter.com/ncrrugby?fbclid=IwAR3tHM239yQskkNNY_4v9Jlz7NvJuRTLul7jLZnuurKp5vLEfj5NVakA2d8">
                        <img src={twitter} alt="Twitter" />
                      </a>
                    </Nav>
                  </Col>
                </Row>
                <Row>
                  <Col className="copyright">
                    <p>&copy; {new Date().getFullYear()} National Collegiate Rugby Organization, LLC.</p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <Nav className="privacy-link">
                      <a className="nav-link" target="_blank" rel="noopener noreferrer" href="https://www.maymadness7s.com/privacy">
                        Privacy Policy
                      </a>
                      <NavLink className="nav-link" to="/terms-and-conditions">
                        Terms & Conditions
                      </NavLink>
                    </Nav>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default Footer;